function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var React = require("react");

var _require = require("@patternplate/component-markdown"),
    MarkdownItem = _require.MarkdownItem,
    MarkdownList = _require.MarkdownList,
    MarkdownLink = _require.MarkdownLink;

module.exports = PatternList;

function PatternList(props) {
  var matches = props.search(props.query);
  return React.createElement(MarkdownList, {
    onClick: props.onClick
  }, matches.map(function (item) {
    return React.createElement(PatternItem, _extends({
      key: item.id
    }, item));
  }));
}

PatternList.defaultProps = {
  items: []
};

function PatternItem(props) {
  var name = props.manifest.displayName || props.manifest.name;
  return React.createElement(MarkdownItem, null, React.createElement("div", {
    "data-type": props.contentType,
    "data-id": props.id
  }, React.createElement(MarkdownLink, {
    href: props.href,
    title: "Open pattern ".concat(name)
  }, name)));
}
//# sourceMappingURL=index.js.map